import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import CTASection from "./components/CTASection";
import SEOContentSection from "./components/SEOContentSection";
import AboutSection from "./components/AboutSection";
import Footer from "./components/Footer";
import HomePageJsonLd from "./components/HomePageJsonLd";

export default function Home() {
  return (
    <main>
      <HomePageJsonLd />
      <Navbar />
      <HeroSection />
      <CategoryGrid />
      <CTASection />
      <SEOContentSection />
      <AboutSection />
      <Footer />
    </main>
  );
}